module.exports = __webpack_public_path__ + "img/出口配置数.daa14d3f.svg";